<template>
  <aside
    class="sms-incident-banner"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="container sms-incident-banner__content">
      <SvgoWavyWarning class="sms-incident-banner__icon" aria-hidden="true"/>
      <p class="sms-incident-banner__text">
        <strong class="sms-incident-banner__title">Временные проблемы с СМС.</strong>
        Авторизация и подтверждение операций по СМС могут быть временно недоступны. Пожалуйста, попробуйте позже.
      </p>
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.sms-incident-banner {
  color: $color-black;
  background: $color-warning;
  border-bottom: 1px solid alpha($color-warning-text, 0.25);

  &__content {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 48px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  &__icon {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    color: $color-warning-text;
  }

  &__text {
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
  }

  &__title {
    font-weight: 700;
  }

  @media (max-width: $screenXs) {
    &__content {
      align-items: flex-start;
    }

    &__icon {
      margin-top: 1px;
    }

    &__title {
      display: block;
      margin-bottom: 2px;
    }
  }
}
</style>
